import {
  ChangeDetectorRef,
  Component, EventEmitter, Input, OnDestroy,
  OnInit, Output
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  BaseSiteService, CmsService,
  GlobalMessageService, GlobalMessageType, LanguageService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { NumberTwo } from '../../../shared/utils/constants/global.constants';
import { CustomRegistrationService } from '../../custom-registration.service';
import {
  globalErrorMsgEng,
  globalErrorMsgFr,
  siteLanguagesEng
} from '../../registration.constants';


const specialCharsRegex = '[^!$%*()=]+$';
const sameAsBillingAddress = 'shippingAddress.sameAsBillingAddress';
const sameasfinanciallyresponse = 'shippingAddress.financialRes';
const yellowFeverForShippingAddr = 'billingAddress.yellowFever';

@Component({
    selector: 'app-shipping-information',
    templateUrl: './shipping-information.component.html',
    styleUrls: ['./shipping-information.component.scss'],
    standalone: false
})
export class ShippingInformationComponent implements OnInit, OnDestroy {
  @Input() formDetails: FormGroup;
  @Input() multiFormData: FormGroup[];
  @Output() pageHeader = new EventEmitter<any>();
  sameasBillingValidation: boolean = false;
  cmsResponse: any;
  finalAssistanceContent: any;
  financialResponsibleValidation: boolean = false;
  shippingForm: FormGroup;
  extensionErrorMsg: boolean = false;
  extensionrepeatErrorMsg: boolean = false;
  billingFormDetails: any;
  multipleForms: FormGroup[] = [];
  provinces: any[] = [];
  isfinancialResponsible: boolean = true;
  practiceOrFacility: any[] = [];
  yellowFever: boolean[] = [true, false];
  isShippingAddressSame: boolean[] = [true, false];
  isfinanciallyresponsible: boolean[] = [true, false];
  errorMessageText: string = globalErrorMsgEng;
  provincSub: Subscription;
  practiceOrFaciltySub: Subscription;
  formTempValue; any;
  creditInvoice: string;
  header: string;
  emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;

  baseSiteId: any;

  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly user: UserAccountFacade,
    private readonly router: Router,
    private readonly languageService: LanguageService,
    private readonly globalMessage: GlobalMessageService,
    private baseSiteService: BaseSiteService,
    private readonly cmsData: CmsService,
    private _dataLayerService: DataLayerService
  ) {

  }

  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe((res) => (this.baseSiteId = res));
    this.header = 'shippingDetails';
    this.creditInvoice = 'invoiceTable';



    this.accountRegService.sectionChange.subscribe((sectionDetails) => {
      this.header = sectionDetails.header;
      this.cdr.detectChanges();
    });

    localStorage.setItem("section", "Billing");

    this.finalAssistanceContent = this.cmsData.getComponentData('NeedAssistanceComponent');

    if (localStorage.getItem('replicateForm') === 'true') {
      this.isfinancialResponsible = false;
    }
    window.scroll(0, 0);
    this.languageService.getActive().subscribe((langRes) => {
      this.errorMessageText =
        langRes === siteLanguagesEng ? globalErrorMsgEng : globalErrorMsgFr;
    });
    this.accountRegService.getPracticeOrFacilityType({
      enumerationType: 'PracticeOrFacilityType',
      fields: 'DEFAULT',
    });
    this.accountRegService.getProvinces({
      fields: 'DEFAULT',
    });
    const maxlengthChar = 256;
    const charlengthSix = 6;
    const maxlengthTwelve = 12;
    const maxlengthSeven = 7;
    const maxlengthFourty = 40;

    this.shippingForm = new FormGroup({
      shippingAddress: new FormGroup({
        facilityName: new FormControl(null, [
          Validators.required,
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        facilityName2: new FormControl(null, [
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        attention: new FormControl(null, [Validators.maxLength(maxlengthChar)]),
        facilityName_repeat2: new FormControl(null, [
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        facilityName_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        attention_repeat: new FormControl(null, [
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        legalName: new FormControl(null, [
          Validators.required,
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        line2: new FormControl(null, [
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        line1: new FormControl(null, [
          Validators.required,
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        line1_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        line2_repeat: new FormControl(null, [
          Validators.pattern(specialCharsRegex),
          Validators.maxLength(maxlengthChar),
        ]),
        town: new FormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z ]+$'),
          Validators.maxLength(maxlengthChar),
        ]),
        town_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z ]+$'),
          Validators.maxLength(maxlengthChar),
        ]),
        region: new FormGroup({
          isocode: new FormControl(null, Validators.required),
          countryIso: new FormControl('CA'),
          name: new FormControl(null, Validators.required),
        }),
        region_repeat: new FormGroup({
          isocode: new FormControl(null, Validators.required),
          countryIso: new FormControl('CA'),
          name: new FormControl(null, Validators.required),
        }),
        postalCode: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$'),
          Validators.maxLength(10),
        ]),
        postalCode_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern('^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$'),
          Validators.maxLength(10),
        ]),
        phone: new FormControl(null, [
          Validators.required,
          Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
          Validators.maxLength(maxlengthTwelve),
        ]),
        phone_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
          Validators.maxLength(maxlengthTwelve),
        ]),
        extension: new FormControl(null, [
          Validators.pattern('[0-9]+$'),
          Validators.maxLength(charlengthSix),
        ]),
        extension_repeat: new FormControl(null, [
          Validators.pattern('[0-9]+$'),
          Validators.maxLength(charlengthSix),
        ]),
        fax: new FormControl(null, [
          Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
          Validators.maxLength(maxlengthTwelve),
        ]),
        gender: new FormControl(null, [Validators.required]),
        confirmEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        email: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        practiceOrFacilityType: new FormControl(null, Validators.required),
        yellowFeverForShippingAddr: new FormControl(null, Validators.required),
        billingAddress: new FormControl(
          this.isShippingAddressSame[1],
          Validators.required
        ),
        shippingAddress: new FormControl(
          this.isShippingAddressSame[1],
          Validators.required
        ),
        sameAsBillingAddress: new FormControl(null, Validators.required),
        sameasfinanciallyresponse: new FormControl(
          this.isfinanciallyresponsible[1],
          Validators.required
        ),
        invoiceEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        confirmInvoiceEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        stmntEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        confirmStmntEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(this.emailRegex),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
      }),
    });


    if (localStorage.getItem('formTempValue') === null) {
      if (!this.shippingForm.value.shippingAddress.yellowFever) {

        const formValues = this.formDetails.value;
        if (localStorage.getItem('finalBillingDetails') != null) {
          let finalBillingDetails = JSON.parse(localStorage.getItem('finalBillingDetails'));
          this.shippingForm.patchValue(
            {
              shippingAddress: {
                facilityName: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.facilityName : formValues.billingAddress.facilityName,
                facilityName2: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.facilityName2 : formValues.billingAddress.facilityName2,
                attention: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.attention : formValues.billingAddress.attention,
                facilityName_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.facilityName_repeat : formValues.billingAddress.facilityName,
                facilityName_repeat2: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.facilityName_repeat2 : formValues.billingAddress.facilityName2,

                attention_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.attention_repeat : formValues.billingAddress.attention,
                line1: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.line1 : formValues.billingAddress.line1,
                line1_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.line1_repeat : formValues.billingAddress.line1_repeat,
                line2: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.line2 : formValues.billingAddress.line2,
                line2_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.line2 : formValues.billingAddress.line2_repeat,
                town: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.town : formValues.billingAddress.town,
                town_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.town_repeat : formValues.billingAddress.town_repeat,
                region: {
                  isocode: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.region.isocode : formValues.billingAddress.region.isocode,
                  countryIso: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.region.countryIso : formValues.billingAddress.region.countryIso,
                },
                region_repeat: {
                  isocode: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.region_repeat.isocode : '',
                  countryIso: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.region_repeat.countryIso : '',
                  name: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.region_repeat.name : '',
                },

                postalCode: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.postalCode : formValues.billingAddress.postalCode,
                postalCode_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.postalCode_repeat : formValues.billingAddress.postalCode_repeat,
                phone: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.phone : formValues.billingAddress.phone,
                phone_repeat: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.phone_repeat : formValues.billingAddress.phone_repeat,
                extension: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.extension : formValues.billingAddress.extension,
                fax: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.fax : formValues.billingAddress.fax,
                email: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.email : formValues.billingAddress.email,
                confirmEmail: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.confirmEmail : formValues.billingAddress.confirmEmail,
                practiceOrFacilityType: localStorage.getItem('finalBillingDetails') != null ? finalBillingDetails.billingAddress.practiceOrFacilityType : formValues.billingAddress.practiceOrFacilityType,
                yellowFeverForShippingAddr: localStorage.getItem('replicateForm') === 'true' ? this.yellowFever[1] : this.yellowFever[0],
                sameAsBillingAddress: localStorage.getItem('finalBillingDetails') != null ? JSON.parse(localStorage.getItem('finalBillingDetails')).sameAsBillingAddress : "",
                sameasfinanciallyresponse: this.shippingForm.value.shippingAddress.sameasfinanciallyresponse,
                invoiceEmail: localStorage.getItem('invoiceEmail') != null ? finalBillingDetails.invoiceEmail : formValues.billingAddress.invoiceEmail,
                confirmInvoiceEmail: localStorage.getItem('confirmInvoiceEmail') != null ? finalBillingDetails.confirmInvoiceEmail : formValues.billingAddress.confirmInvoiceEmail,
                stmntEmail: localStorage.getItem('stmtEmail') != null ? finalBillingDetails.stmntEmail : formValues.billingAddress.stmntEmail,
                confirmStmntEmail: localStorage.getItem('confirmStmntEmail') != null ? finalBillingDetails.confirmStmntEmail : formValues.billingAddress.confirmStmntEmail
              },
            },
            { emitEvent: false }
          );
        }
      }
      else {

        const formValues = this.formDetails.value;
        this.shippingForm.patchValue(
          {
            shippingAddress: {
              facilityName: formValues.billingAddress.facilityName,
              facilityName2: formValues.billingAddress.facilityName2,
              attention: formValues.billingAddress.attention,
              facilityName_repeat: formValues.billingAddress.facilityName_repeat,
              facilityName_repeat2: formValues.billingAddress.facilityName_repeat2,
              attention_repeat: formValues.billingAddress.attention_repeat,
              line1: formValues.billingAddress.line1,
              line1_repeat: formValues.billingAddress.line1_repeat,
              line2: formValues.billingAddress.line2,
              town: formValues.billingAddress.town,
              town_repeat: formValues.billingAddress.town_repeat,
              region: {
                isocode: formValues.billingAddress.region.isocode,
                countryIso: formValues.billingAddress.region.countryIso,
              },
              region_repeat: {
                isocode: formValues.billingAddress.region_repeat.isocode,
                countryIso: formValues.billingAddress.region_repeat.countryIso,
              },
              postalCode: formValues.billingAddress.postalCode,
              postalCode_repeat: formValues.billingAddress.postalCode_repeat,
              phone: formValues.billingAddress.phone,
              phone_repeat: formValues.billingAddress.phone_repeat,
              extension: formValues.billingAddress.extension,
              fax: formValues.billingAddress.fax,
              email: formValues.billingAddress.email,
              confirmEmail: formValues.billingAddress.confirmEmail,
              practiceOrFacilityType: formValues.billingAddress.practiceOrFacilityType,
              sameasfinanciallyresponse: this.shippingForm.value.shippingAddress.sameasfinanciallyresponse,
              invoiceEmail: formValues.billingAddress.invoiceEmail,
              confirmInvoiceEmail: formValues.billingAddress.confirmInvoiceEmail,
              stmntEmail: formValues.billingAddress.stmntEmail,
              confirmStmntEmail: formValues.billingAddress.confirmStmntEmail,
            },
          },
          { emitEvent: false }
        );
      }
    }
    else {
      let formValues;

      if (localStorage.getItem('finalBillingDetails') != null) {
        if (!localStorage.getItem('finalBillingDetails')["sameAsBillingAddress"]) {
          formValues = JSON.parse(localStorage.getItem('finalBillingDetails'));
        }
        else {
          formValues = JSON.parse(localStorage.getItem('formTempValue'));
        }
      }
      this.shippingForm.patchValue(
        {
          shippingAddress: {
            facilityName: formValues.facilityName,
            facilityName2: formValues.facilityName2,
            attention: formValues.attention,
            attention_repeat: formValues.attention_repeat,
            facilityName_repeat: formValues.facilityName_repeat,
            facilityName_repeat2: formValues.facilityName_repeat2,
            line1: formValues.line1,
            line1_repeat: formValues.line1_repeat,
            line2: formValues.line2,
            line2_repeat: formValues.line2_repeat,
            town: formValues.town,
            town_repeat: formValues.town_repeat,
            region: {
              isocode: formValues.region.isocode,
              countryIso: formValues.region.countryIso,
            },
            region_repeat: {
              isocode: formValues.region_repeat.isocode,
              countryIso: formValues.region_repeat.countryIso,
            },
            postalCode: formValues.postalCode,
            postalCode_repeat: formValues.postalCode_repeat,
            phone: formValues.phone,
            phone_repeat: formValues.phone_repeat,
            extension: formValues.extension,
            extension_repeat: formValues.extension_repeat,
            fax: formValues.fax,
            email: formValues.email,
            confirmEmail: formValues.confirmEmail,
            practiceOrFacilityType:
              formValues.practiceOrFacilityType,
            yellowFeverForShippingAddr: localStorage.getItem('replicateForm') === 'true' ? this.yellowFever[1] : this.yellowFever[0],

            sameAsBillingAddress: formValues.sameAsBillingAddress,
            sameasfinanciallyresponse: formValues.sameasfinanciallyresponse,
            invoiceEmail: formValues.invoiceEmail,
            confirmInvoiceEmail: formValues.confirmInvoiceEmail,
            stmntEmail: formValues.stmntEmail,
            confirmStmntEmail: formValues.confirmStmntEmail,
          },
        },
        { emitEvent: false }
      );
    }

    this.populateDataFromMultiForm();

    this.provincSub = this.accountRegService.provinceData$.subscribe((res) => {
      if (res !== false) {
        this.provinces = res?.regions;
      }
    });

    this.practiceOrFaciltySub =
      this.accountRegService.practiceOrFacilityTypeData$.subscribe(
        (response) => {
          if (response !== false) {
            this.practiceOrFacility = response;
          }
        }
      );

    this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_step', 'billing');
  }

  sameasBillingValue(val) {
    this.sameasBillingValidation = false;
    if (val) {

      const formValues = JSON.parse(localStorage.getItem("billingFormDetails"));

      this.shippingForm.patchValue(
        {
          shippingAddress: {
            facilityName: formValues.facilityName,
            facilityName2: formValues.facilityName2,
            attention: formValues.attention,
            attention_repeat: formValues.attention_repeat,
            facilityName_repeat2: formValues.facilityName_repeat2,
            line1: formValues.line1,
            line2: formValues.line2,
            town: formValues.town,
            region: {
              isocode: formValues.region.isocode,
              countryIso: formValues.region.countryIso,
            },
            postalCode: formValues.postalCode,
            phone: formValues.phone,
            extension: formValues.extension,
            fax: formValues.fax,
            email: formValues.email,
            confirmEmail: formValues.confirmEmail,
            practiceOrFacilityType:
              formValues.practiceOrFacilityType,
            yellowFever: formValues.yellowFever,
            sameasfinanciallyresponse: formValues.sameasfinanciallyresponse,
            invoiceEmail: formValues.invoiceEmail,
            confirmInvoiceEmail: formValues.confirmInvoiceEmail,
            stmntEmail: formValues.stmntEmail,
            confirmStmntEmail: formValues.confirmStmntEmail,
          },
        },
        { emitEvent: false }
      );
    }
    else {



      this.shippingForm.patchValue(
        {
          shippingAddress: {
            facilityName: "",
            facilityName2: "",
            attention: "",
            line1: "",
            line2: "",
            town: "",
            region: {
              isocode: null,
              countryIso: null,
            },
            postalCode: "",
            phone: "",
            extension: "",
            fax: "",
            email: "",
            confirmEmail: "",
            practiceOrFacilityType: "",
            yellowFever: "",
            sameasfinanciallyresponse: '',
            invoiceEmail: '',
            confirmInvoiceEmail: '',
            stmntEmail: '',
            confirmStmntEmail: '',
          },
        },
        { emitEvent: false }
      );


      this.provincSub = this.accountRegService.provinceData$.subscribe((res) => {
        if (res !== false) {
          this.provinces = res?.regions;
        }
      });
      if (this.shippingForm.value.shippingAddress.region.isocode != null) {
        let found = this.provinces.find(e => e.isocode === this.shippingForm.value.shippingAddress.region.isocode);


        this.shippingForm.patchValue(
          {
            shippingAddress: {
              region: {
                name: found.name,
              },
            }
          });
      }

      if (localStorage.getItem("finalBillingDetails") != null) {

        this.shippingForm.patchValue(
          {
            shippingAddress: {
              facilityName: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName,
              facilityName2: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName2,
              attention: JSON.parse(localStorage.getItem("finalBillingDetails")).attention,
              attention_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).attention_repeat,
              facilityName_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName_repeat,
              facilityName_repeat2: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName_repeat2,
              line1: JSON.parse(localStorage.getItem("finalBillingDetails")).line1,
              line2: JSON.parse(localStorage.getItem("finalBillingDetails")).line2,
              town: JSON.parse(localStorage.getItem("finalBillingDetails")).town,
              region: {
                isocode: JSON.parse(localStorage.getItem("finalBillingDetails")).region.isocode,
                countryIso: JSON.parse(localStorage.getItem("finalBillingDetails")).region.countryIso,
                name: JSON.parse(localStorage.getItem("finalBillingDetails")).region.name
              },
              postalCode: JSON.parse(localStorage.getItem("finalBillingDetails")).postalCode,
              phone: JSON.parse(localStorage.getItem("finalBillingDetails")).phone,
              extension: JSON.parse(localStorage.getItem("finalBillingDetails")).extension,
              fax: JSON.parse(localStorage.getItem("finalBillingDetails")).fax,
              email: JSON.parse(localStorage.getItem("finalBillingDetails")).email,
              confirmEmail: JSON.parse(localStorage.getItem("finalBillingDetails")).confirmEmail,
              practiceOrFacilityType: JSON.parse(localStorage.getItem("finalBillingDetails")).practiceOrFacility,
              yellowFever: null,
              sameasfinanciallyresponse: null,
              invoiceEmail: JSON.parse(localStorage.getItem('finalBillingDetails')).invoiceEmail,
              confirmInvoiceEmail: JSON.parse(localStorage.getItem('finalBillingDetails')).confirmInvoiceEmail,
              stmntEmail: JSON.parse(localStorage.getItem('finalBillingDetails')).stmtEmail,
              confirmStmntEmail: JSON.parse(localStorage.getItem('finalBillingDetails')).confirmStmntEmail,
            },
          },
          { emitEvent: false }
        );
      }
      else {
        localStorage.setItem("formTempValue", JSON.stringify(this.shippingForm.value));
        const formValues = this.formDetails.value;

        this.shippingForm.patchValue(
          {
            shippingAddress: {
              facilityName: "",
              facilityName2: "",
              attention: "",
              attention_repeat: "",
              facilityName_repeat2: "",
              line1: "",
              line2: "",
              town: "",
              region: {
                isocode: null,
                countryIso: null,
              },
              postalCode: "",
              phone: "",
              extension: "",
              fax: "",
              email: "",
              confirmEmail: "",
              practiceOrFacilityType: "",
              yellowFever: "",
              sameasfinanciallyresponse: "",
              invoiceEmail: '',
              confirmInvoiceEmail: '',
              stmntEmail: '',
              confirmStmntEmail: '',
            },
          },
          { emitEvent: false }
        );
      }
    }






  }
  populateDataFromMultiForm() {
    if (!!this.multiFormData) {
      const len = this.multiFormData.length;
      if (len === 1) {
        this.formDetails = this.multiFormData[len - 1];
        const formValues = this.multiFormData[len - 1].value;
        this.formFillup(formValues.billingAddress);
        if (!!this.shippingForm.get(sameAsBillingAddress).value) {
          this.shippingForm
            .get(yellowFeverForShippingAddr)
            .disable({ emitEvent: false });
        }
      } else if (len === NumberTwo) {
        this.formDetails = this.multiFormData[len - NumberTwo];
        const formValues = this.multiFormData[len - 1].value;
        this.formFillup(formValues.shippingAddress);
        if (!!this.shippingForm.get(sameAsBillingAddress).value) {
          this.shippingForm
            .get(yellowFeverForShippingAddr)
            .disable({ emitEvent: false });
        }
      } else {

      }
    }
  }
  validationExtension(e, type) {
    if (e.length > 6) {
      if (type === 'extnson') {
        this.extensionErrorMsg = true;
      }
      if (type === 'extnson_rpt') {
        this.extensionrepeatErrorMsg = true;
      }
    }
    else {
      if (type === 'extnson') {
        this.extensionErrorMsg = false;
      }
      if (type === 'extnson_rpt') {
        this.extensionrepeatErrorMsg = false;
      }
    }
  }
  formFillup(form: any) {
    this.shippingForm.setValue(
      {
        shippingAddress: {
          facilityName: form.facilityName,
          attention: form.attention,
          line1: form.line1,
          line2: form.line2,
          town: form.town,
          region: {
            isocode: form.region.isocode,
            countryIso: form.region.countryIso,
          },
          postalCode: form.postalCode,
          phone: form.phone,
          extension: form.extension,
          fax: form.fax,
          email: form.email,
          confirmEmail: form.confirmEmail,
          practiceOrFacilityType: form.practiceOrFacilityType,
          yellowFever: form.yellowFever,
          billingAddress: form.billingAddress,
          shippingAddress: true,
          stmntEmail: form.stmntEmail,
          confirmStmntEmail: form.confirmStmntEmail,
          invoiceEmail: form.invoiceEmail,
          confirmInvoiceEmail: form.confirmInvoiceEmail,
          sameAsBillingAddress:
            form?.sameAsBillingAddress === false
              ? form?.sameAsBillingAddress
              : true,
        },
      },
      { emitEvent: false }
    );
  }

  notEmptyValidator(control: any) {
    const isEmpty = control === null || control === undefined || String(control).trim() === '';
    return !isEmpty;
  }

  proceedToContacts() {
    this.shippingForm.markAllAsTouched();

    if (this.shippingForm.value.shippingAddress.sameAsBillingAddress == null) {
      this.sameasBillingValidation = true;
      this.globalMessage.add(
        'Please correct the errors below.',
        GlobalMessageType.MSG_TYPE_ERROR
      );
      window.scroll(0, 0);
      this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'billing', 'tab');
    }
    if (this.shippingForm.value.shippingAddress.yellowFeverForShippingAddr == null) {
      this.financialResponsibleValidation = true;
      this.globalMessage.add(
        "Please correct the errors below.",
        GlobalMessageType.MSG_TYPE_ERROR
      );
      window.scroll(0, 0);
      this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'billing', 'tab');
    }
    if (this.shippingForm.value.shippingAddress.sameAsBillingAddress != null && this.shippingForm.value.shippingAddress.yellowFeverForShippingAddr != null) {
      this.sameasBillingValidation = false;
      this.financialResponsibleValidation = false;
      let region_name = this.provinces.find(e => e.isocode === this.shippingForm.value.shippingAddress.region.isocode);
      let region_name_repeat = this.provinces.find(e => e.isocode === this.shippingForm.value.shippingAddress.region_repeat.isocode);

      if (region_name !== undefined) {
        this.shippingForm.patchValue(
          {
            shippingAddress: {
              region: {
                name: region_name.name != null ? region_name.name : '',
              }
            }
          });
      }
      if (region_name_repeat !== undefined) {
        this.shippingForm.patchValue(
          {
            shippingAddress: {
              region_repeat: {
                name: region_name_repeat.name != null ? region_name_repeat.name : '',
              }
            }
          });
      }



      localStorage.setItem('finalBillingDetails', JSON.stringify(this.shippingForm.value["shippingAddress"]));
      this.shippingForm.markAllAsTouched();
      const cummulativeFormData = { shipping: [], billing: [], contacts: [] };
      if (localStorage.getItem('replicateForm') === 'true') {
        if (this.shippingForm.value.shippingAddress.facilityName !== '' && this.shippingForm.value.shippingAddress.town !== '' && this.shippingForm.value.shippingAddress.town_repeat !== '' && this.shippingForm.value.shippingAddress.facilityName_repeat !== '' && this.shippingForm.value.shippingAddress.line1_repeat !== '' && this.shippingForm.value.shippingAddress.line1 !== '' && this.shippingForm.value.shippingAddress.phone_repeat !== '' && this.shippingForm.value.shippingAddress.phone !== '' && this.shippingForm.value.shippingAddress.postalCode !== '' && this.shippingForm.value.shippingAddress.postalCode_repeat !== '' && this.shippingForm.value.shippingAddress.region.isocode !== '' && this.shippingForm.value.shippingAddress.region_repeat.isocode !== '') {
          this.shippingForm.value.shippingAddress.status = 'VALID';
        }
        else {
          this.shippingForm.value.shippingAddress.status = 'INVALID';
        }
      }
      else {
        if (this.shippingForm.value.shippingAddress.facilityName !== '' && this.shippingForm.value.shippingAddress.line1 !== '' && this.shippingForm.value.shippingAddress.phone !== '' && this.shippingForm.value.shippingAddress.postalCode !== '' && this.shippingForm.value.shippingAddress.region.name !== '' && this.shippingForm.value.shippingAddress.town !== '') {
          this.shippingForm.value.shippingAddress.status = 'VALID';
        }
      }

      if (
        !this.notEmptyValidator(this.shippingForm.value.shippingAddress.invoiceEmail) ||
        !this.notEmptyValidator(this.shippingForm.value.shippingAddress.confirmInvoiceEmail) ||
        this.shippingForm.value.shippingAddress.invoiceEmail != this.shippingForm.value.shippingAddress.confirmInvoiceEmail
      ) {
        this.globalMessage.add(
          'Please correct the errors below.',
          GlobalMessageType.MSG_TYPE_ERROR
        );
        window.scroll(0, 0);
        this.shippingForm.value.shippingAddress.status = 'INVALID';
      } else this.shippingForm.value.shippingAddress.status = 'VALID';

      if (
        !this.notEmptyValidator(this.shippingForm.value.shippingAddress.stmntEmail) ||
        !this.notEmptyValidator(this.shippingForm.value.shippingAddress.confirmStmntEmail) ||
        this.shippingForm.value.shippingAddress.stmntEmail != this.shippingForm.value.shippingAddress.confirmStmntEmail
      ) {
        this.globalMessage.add(
          'Please correct the errors below.',
          GlobalMessageType.MSG_TYPE_ERROR
        );
        window.scroll(0, 0);
        this.shippingForm.value.shippingAddress.status = 'INVALID';
      } else this.shippingForm.value.shippingAddress.status = 'VALID';

      if (this.shippingForm.value.shippingAddress.status === 'VALID' &&
        this.shippingForm.get('shippingAddress.email').value ===
        this.shippingForm.get('shippingAddress.confirmEmail').value
      ) {

        if (this.shippingForm.get(sameAsBillingAddress).value === true) {
          this.formDetails.patchValue(
            {
              billingAddress: {
                shippingAddress:
                  this.shippingForm.get(sameAsBillingAddress).value,
              },
            },
            { emitEvent: false }
          );


          cummulativeFormData.shipping.push(
            this.formDetails.get('billingAddress').value
          );
          cummulativeFormData.billing.push(this.shippingForm.value.shippingAddress);
          this.multipleForms.push(this.formDetails);
        }
        else {


          this.shippingForm.patchValue(
            {
              shippingAddress:
                this.shippingForm.get('shippingAddress').value
            },
            { emitEvent: false }
          );




          cummulativeFormData.shipping.push(
            this.formDetails.get('billingAddress').value
          );
          cummulativeFormData.billing.push(
            this.shippingForm.get('shippingAddress').value
          );
          localStorage.removeItem("formTempValue");

          let found = this.provinces.find(e => e.isocode === this.shippingForm.value.shippingAddress.region.isocode);


          this.shippingForm.patchValue(
            {
              shippingAddress: {
                region: {
                  name: found.name,
                },
              }
            });


          localStorage.setItem("formTempValue", JSON.stringify(this.shippingForm.get('shippingAddress').value));


          this.multipleForms.push(this.formDetails);
          this.multipleForms.push(this.shippingForm);
        }


        const shippingDetails = {
          header: 'contacts',
          forms: this.multipleForms,
          totalFormData: cummulativeFormData,
        };

        this.pageHeader.emit(shippingDetails);

















































      } else {
        const shippingDetails_copy = {
          header: 'contacts',
          forms: this.multipleForms,
          totalFormData: cummulativeFormData,
        };
        window.scroll(0, 0);
        this.shippingForm.markAllAsTouched();
        this.globalMessage.add(
          this.errorMessageText,
          GlobalMessageType.MSG_TYPE_ERROR
        );

      }
    }

  }

  back() {
    if (!!this.multiFormData === false) {
      this.multiFormData = [];
      this.multiFormData.push(this.formDetails);
    }
    const shippingDetails = {
      header: 'billingDetails',
      form: this.formDetails,
      forms: this.multiFormData,
    };
    this.pageHeader.emit(shippingDetails);
    this.accountRegService.sectionChange.next(shippingDetails);
  }

  ngOnDestroy() {
    this.provincSub?.unsubscribe();
    this.practiceOrFaciltySub?.unsubscribe();
  }

  replicateForm(val: any) {

    this.financialResponsibleValidation = false;
    if (val === 'Y') {
      localStorage.removeItem('replicateForm');
      this.isfinancialResponsible = true;
    }
    else {

      localStorage.setItem('replicateForm', 'true')

      this.isfinancialResponsible = false;
      this.shippingForm.patchValue({
        shippingAddress: {
          yellowFeverForShippingAddr: false
        }
      })
    }

    if (localStorage.getItem("finalBillingDetails") != null) {
      if (JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName_repeat === "") {
        this.shippingForm.patchValue(
          {
            shippingAddress: {

              facilityName_repeat: "",
              facilityName_repeat2: "",
              attention_repeat: "",
              line1_repeat: "",
              line2_repeat: "",
              town_repeat: "",

              region_repeat: {
                isocode: "",
                countryIso: "",
              },
              postalCode_repeat: "",
              phone_repeat: "",
              yellowFever: true,

            },
          },
          { emitEvent: false }
        );
      }
      else {
        this.shippingForm.patchValue(
          {
            shippingAddress: {

              facilityName_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName_repeat,
              facilityName_repeat2: JSON.parse(localStorage.getItem("finalBillingDetails")).facilityName_repeat2,
              attention_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).attention_repeat,
              line1_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).line1_repeat,
              line2_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).line2_repeat,
              town_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).town_repeat,

              region_repeat: {
                isocode: JSON.parse(localStorage.getItem("finalBillingDetails")).region_repeat.isocode,
                countryIso: JSON.parse(localStorage.getItem("finalBillingDetails")).countryIso,
              },
              postalCode_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).postalCode_repeat,
              phone_repeat: JSON.parse(localStorage.getItem("finalBillingDetails")).phone_repeat,
              yellowFever: true,
              invoiceEmail: JSON.parse(localStorage.getItem("finalBillingDetails")).invoiceEmail,
              confirmInvoiceEmail: JSON.parse(localStorage.getItem("finalBillingDetails")).confirmInvoiceEmail,
              stmntEmail: JSON.parse(localStorage.getItem("finalBillingDetails")).stmtEmail,
              confirmStmntEmail: JSON.parse(localStorage.getItem("finalBillingDetails")).confirmStmntEmail,
            },
          },
          { emitEvent: false }
        );
      }
    }
    else {
      this.shippingForm.patchValue(
        {
          shippingAddress: {

            facilityName_repeat: "",
            facilityName_repeat2: "",
            attention_repeat: "",
            line1_repeat: "",
            line2_repeat: "",
            town_repeat: "",

            region_repeat: {
              isocode: "",
              countryIso: "",
            },
            postalCode_repeat: "",
            phone_repeat: "",
            yellowFever: true,

          },
        },
        { emitEvent: false }
      );
    }
  }

  onShippingAddress(place: google.maps.places.PlaceResult, idSubfix?: string) {
    var streetNumber: string;
    var route: string;
    var locality: string;
    var country: string;
    var postalCode: string;
    var subpremise: string;
    var neighborhood: string;
    var sublocality: string;
    var adminArea: string;
    var postalSuffix: string;
    var chosenAddress = place.formatted_address ?? '';

    const components = place.address_components;

    components.forEach((component) => {
      if (component.types.includes('street_number')) streetNumber = component.long_name || '';
      else if (component.types.includes('route')) route = component.long_name || '';
      else if (component.types.includes('subpremise')) subpremise = component.long_name || '';
      else if (component.types.includes('neighborhood')) neighborhood = component.long_name || '';
      else if (component.types.includes('sublocality')) sublocality = component.long_name || '';
      else if (component.types.includes('locality')) locality = component.long_name || '';
      else if (component.types.includes('administrative_area_level_1')) adminArea = component.short_name || '';
      else if (component.types.includes('country')) country = component.short_name || '';
      else if (component.types.includes('postal_code')) postalCode = component.long_name || '';
      else if (component.types.includes('postal_code_suffix')) postalSuffix = component.long_name || '';
    });

    if (!streetNumber && route) {
      const match = route.match(/^(\d+)\s+(.*)/);
      if (match) {
        streetNumber = match[1];
        route = match[2] || '';
      }
    }

    let line1 = [streetNumber, route].filter(Boolean).join(' ').toUpperCase() || '';
    let line2 = subpremise ? subpremise.toUpperCase() : '';
    let town = (neighborhood || sublocality || locality || '').toUpperCase();
    let fullPostalCode = postalSuffix ? `${postalCode}-${postalSuffix}` : postalCode || '';
    let regionIso = country && adminArea ? `${country}-${adminArea}`.toUpperCase() : '';

    idSubfix = idSubfix ? idSubfix : '';
    this.shippingForm.controls.shippingAddress.get('line1' + idSubfix)?.setValue(line1);
    this.shippingForm.controls.shippingAddress.get('line2' + idSubfix)?.setValue(line2);
    this.shippingForm.controls.shippingAddress.get('town' + idSubfix)?.setValue(town);
    this.shippingForm.controls.shippingAddress.get('postalCode' + idSubfix)?.setValue(fullPostalCode);
    this.shippingForm.controls.shippingAddress.get('region' + idSubfix + '.isocode').setValue(regionIso);
  }

}
